import {Component} from "react";
import {injectIntl} from "react-intl";
import connect from "react-redux/es/connect/connect";
import {withRouter} from 'react-router-dom'
import React from "react";
import {
  Card, Col, Row, List, Progress, Tooltip
} from 'antd'
import {CircleChartAssets} from "./CircleChart";
import {setAssetType, setAdvancedSearchEnabled} from "../../actions/AppAction";
import {getStorageHistory, getFolderSpace, getAssetsList} from "../../actions/StorageAction";
import { isEnterpriseUser } from "../../utils/plan-utils";

export class DashboardAssets extends Component {
  constructor(props) {
    super(props);

    this.state = {
      spaceMonth: []
    }
  }

  componentDidMount() {
    const {
      workclient,
      intl,
    } = this.props;
    this.props.getFolderSpace(workclient);
    this.props.getAssetsList(workclient, intl);
    this.props.getStorageHistory(workclient);
  }

  handleOnClickShowHide = (assetType) => {
    this.props.setAssetType(assetType);
    this.props.setAdvancedSearchEnabled(true);
  };

  render() {
    const {contractedSpace, intl, handleShowAddModalUser,newColor, storageHistory, folderSpace, folderSpaceInBytes, assetsList, totalAssets, client} = this.props;
    const sizeMoment = (folderSpaceInBytes / Math.pow(2,30)).toFixed(2);
    return (
      <React.Fragment>
        <Card title={intl.formatMessage({id: 'assets_title'})} id="assets-card" hoverable>
          <Row gutter={25} style={{display: 'flex'}}>
            <Col lg={8} md={12} xs={24} span={8} style={{margin: 'auto'}}>
              <div style={{height: "150px", width: "150px", display: "block", margin: "0 auto"}}>
                <CircleChartAssets assetList={assetsList}
                  folderSpaceInBytes={folderSpaceInBytes}
                  contractedSpaceInGb={contractedSpace}/>
              </div>
              <p style={{ marginTop: 15, color: '#8E8E8E', fontWeight: 400, fontSize: 15, }}>{folderSpace} / {contractedSpace} GB</p>
              <Card style={{ minHeight: '0px', paddingTop: '20px'}} hidden={parseFloat(sizeMoment) < parseFloat(Math.floor(contractedSpace).toFixed(2)) || isNaN(parseFloat(sizeMoment)) ? true: false}>
                <h5 style={{color: 'red'}}><b>Ha llegado o esta llegando al limite de espacio que puede subir</b></h5>
              </Card>
              {!isEnterpriseUser(client) &&  <div>
                <Tooltip>
                  <button className="ant-btn ant-btn-primary" style={{backgroundColor: newColor, borderColor: newColor, marginBottom: '34px'}} onClick={() => handleShowAddModalUser()}>
                    {intl.formatMessage({id: "buy_storage"})}
                  </button>
                </Tooltip>
              </div>}
            </Col>
            <Col lg={8} md={12} xs={24} span={8}>
              <List
                style={{borderRadius: '10px', marginBottom: '10px', border: '1px solid #efefef', }}
                header={<div className="container" style={{paddingLeft: 0, paddingRight: 0}}>
                  <Row>
                    <Col span={16} style={{textAlign: "left"}}><b>{intl.formatMessage({id: 'total_assets'})}</b></Col>
                    <Col span={8} style={{textAlign: "right"}}><b>{totalAssets}</b></Col>
                  </Row>
                </div>}
                footer={<div className="container" style={{paddingLeft: 0, paddingRight: 0}}>
                  <Row>
                    <Col span={16} style={{textAlign: "left"}}><b>{intl.formatMessage({id: 'stored_weight'})}</b></Col>
                    <Col span={8} style={{textAlign: "right"}}><b>{folderSpace}</b></Col>
                  </Row>
                </div>}
                bordered
                dataSource={assetsList}
                renderItem={(item) => (
                  <List.Item style={{padding: "3px 0px", borderBottom: 0}}
                             onClick={() => this.handleOnClickShowHide(item.type)}>
                    <div className="container">
                      <Row>
                        <Col  span={16} style={{textAlign: "left"}}><span
                          style={{background: item.background}} className="circle"/>{item.title}</Col>
                        <Col span={8} style={{textAlign: "right"}}>{item.qty}</Col>
                      </Row>
                    </div>
                  </List.Item>
                )}
              />
            </Col>
            <Col lg={8} md={24} xs={24} span={8}>
              <List
                style={{ marginTop: "15px"}}
                dataSource={storageHistory}
                renderItem={(item) => (
                  <List.Item style={{padding: "3px 0px", borderBottom: 0}}>
                    <div className="container">
                      <Row gutter={16}>
                        <Col span={10} style={{textAlign: "left"}}>{item.nombre}</Col>
                        <Col span={14} style={{textAlign: "right"}}>
                          <Progress percent={item.porcentaje} showInfo={false}/>
                        </Col>
                      </Row>
                    </div>
                  </List.Item>
                )}
              />
            </Col>
          </Row>
        </Card>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  newColor: state.authUser.user && state.authUser.user.color ? state.authUser.user.color : '#2E97CF',
  storageHistory: state.storage.history,
  folderSpace: state.storage.folderSpace,
  folderSpaceInBytes: state.storage.folderSpaceInBytes,
  assetsList: state.storage.assetsList,
  totalAssets: state.storage.totalAssets,
  client: state.client.data,
});

const mapDispatchToProps = {
  setAssetType,
  setAdvancedSearchEnabled,
  getStorageHistory,
  getFolderSpace,
  getAssetsList
};

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(DashboardAssets)))
